'use strict';

class HelpCenterWidget {
	constructor(props = {}) {
		console.log('HelpCenterWidget::constructor(%o)', props);
		let _that = this;

		_that.elements = {
			help_widget_btn: document.querySelector('.help_widget'),
			widget_form_holder: document.querySelector('.widget_form_holder'),
			answer_holder: document.getElementById('answer_holder'),
			contact_holder: document.getElementById('contact_holder'),
			main_menu: document.getElementById('main_menu'),
			help_center_widget: document.getElementById('help_center_widget'),
			search_btn: document.getElementById('go_search'),
			search_input: document.getElementById('search_input')
		};
		_that.widget_toggled = false;
		_that.widget_first_opened = false;
		_that.chat_agents_online = false;
		_that.click_number = 0;
		_that.last_search_string = 'default_page_questions';
		_that.idle_timer = null;
		_that.idle_time = 180000;
		_that.idle_time_amount = 180000;

		_that.page_ajax = {
			help_widget_settings: null,
			log_click: null,
			search: null
		};

		_that = Object.assign(this, props);

		_that.pageEvents();
	}

	pageEvents() {
		const _that = this;

		if (_that.elements.help_widget_btn) {
			_that.elements.help_widget_btn.addEventListener('click', () => {
				if (!_that.widget_first_opened) {
					trackEvent('Help Center Widget', 'Widget Open', 'First load open');
					if (window.outerWidth < 768) {
						window.location = url('/help_center');
						return;
					}
					if (_that.elements.main_menu) {
						_that.setWidgetHeights();
					}

					_that.widget_first_opened = true;

					_that.prepareForm();

					if (_that.elements.widget_form_holder) {
						_that.elements.widget_form_holder.classList.remove('hidden');
					}

					if (!_that.idle_timer) {
						_that.idle_timer = setInterval(() => {
							_that.calculateIdle();
						}, 1000);
					}
				} else {
					if (_that.widget_toggled) {
						_that.closeWidget();
					} else {
						_that.showWidget();
					}
				}

				_that.toggleWidgetIcon();
				_that.widget_toggled = !_that.widget_toggled;
			});

			if (window.localStorage.getItem('question_id') !== null && window.outerWidth > 768) {
				_that.elements.help_widget_btn.click();
			}
		}

		if (_that.elements.search_btn) {
			_that.elements.search_btn.addEventListener('click', e => {
				e.preventDefault();
				_that.handleSearchString();
			});
		}

		if (_that.elements.search_input) {
			_that.elements.search_input.addEventListener('keyup', e => {
				if (e.key === 'Enter') {
					_that.handleSearchString();
				}
			});
		}

		if (_that.elements.widget_form_holder) {
			_that.elements.widget_form_holder.addEventListener('click', () => {
				_that.idle_time = _that.idle_time_amount;
			});
		}
	}

	search(search_string, max_q = 5) {
		const _that = this;

		trackEvent('Help Center Widget', 'Search', search_string);
		_that.last_search_string = search_string;
		const help_center_button = document.getElementById('go_to_helpcenter');
		if (help_center_button) {
			help_center_button.setAttribute('href', url('/help_center', {'help_center_question': search_string}));
		}

		const form_data = new FormData();
		form_data.append('action', 'search');
		form_data.append('message', search_string);
		form_data.append('max_q', max_q);
		form_data.append('auto', null);

		_that.page_ajax.search = _that.doAjax(
			url('/help_center_process'),
			form_data
		);
		_that.page_ajax.search.fetch_promise.then(response => {
			const suggestions = response.suggestions || [];
			_that.elements.search_btn.innerHTML = _that.createSVG(
				'0 0 24 24',
				['search_icon', 'icon'],
				'#svg_search_icon'
			);
			_that.removeChatButton();
			_that.elements.answer_holder.innerHTML = '';
			if (suggestions.length > 0) {
				const questions = [];
				questions.push({search_string: search_string});
				for (let i = 0; i < suggestions.length; i++) {
					questions.push(suggestions[i].question);
				}
				trackEvent('Help Center Widget', 'Search Result', JSON.stringify(questions));
				_that.addToLocalStorage('questions', suggestions);
				_that.elements.answer_holder.innerHTML = _that.generateQuestionList(suggestions);
				_that.bindQuestionClick();
				_that.elements.answer_holder.classList.remove('hidden');
			} else {
				trackEvent('Help Center Widget', 'Empty Result Set', search_string);
				_that.elements.answer_holder.innerHTML = `
					<div class='d-flex justify-content-center align-items-center no_results'>
						<svg viewBox='0 0 80 54' class='opacity-1' style='width: 80px; height: 54px;'>
							<use xlink:href='#svg_logo'></use>
						</svg>
						<div class='font-size18 margin_vertical20 text-center'>
							<p class='text-center margin_bottom20'><strong>${it('NO_RESULTS')}</strong></p>
							<ul class='font-size14 hw_no_results text-left'>
								<li>${it('NO_RESULTS_1')}</li>
								<li>${it('NO_RESULTS_2')}</li>
								<li>${it('NO_RESULTS_3')}</li>
							</ul>
						</div>
					</div>
				`;
			}
		});
	}

	createSVG(viewBox, classes, uses) {
		return `
			<svg viewBox='${viewBox}' class='${classes.map(c => c).join(' ')}'>
				<use xlink:href='${uses}'></use>
			</svg>
		`;
	}

	logClick(question_id) {
		const _that = this;
		_that.click_number++;

		if (!_that.existsInLocalStorage('question_id')) {
			try {
				const form_data = new FormData();
				form_data.append('action', 'log');
				form_data.append('from', 'widget');
				form_data.append('message', _that.last_search_string);
				form_data.append('question_id', question_id);
				form_data.append('click_number', _that.click_number);
				_that.page_ajax.log_click = _that.doAjax(
					url('/help_center_process'),
					form_data
				);
				console.log('HelpCenterWidget::logClick question(%o) success', question_id);
				_that.page_ajax.log_click.fetch_promise.then(response => {
				});
			} catch (e) {
				console.error('HelpCenterWidget::logClick question(%o) failed', question_id);
			}
		}
	}

	calculateNewWidgetHeights(element, relative_to) {
		const _that = this;

		const top_offset = _that.cumulativeOffset(element).top;
		const relative_to_height = relative_to.offsetHeight;
		const real_top_offset = top_offset - relative_to_height - 485;

		return {
			holder_height: 475 + real_top_offset,
			answer_holder_height: 335 + real_top_offset,
			contact_holder_height: 475 - 30 + real_top_offset,
			offset_top: real_top_offset
		};
	}

	cumulativeOffset(element) {
		let top = 0, left = 0;
		do {
			top += element.offsetTop || 0;
			left += element.offsetLeft || 0;
			element = element.offsetParent;
		} while (element);

		return {
			top: top,
			left: left
		};
	}

	removeChatButton() {
		const chat_button_existing = document.getElementById('hw_chat');
		if (chat_button_existing && !chat_button_existing.classList.contains('not-visible')) {
			if (chat_button_existing.parentNode !== null) {
				chat_button_existing.parentNode.removeChild(chat_button_existing);
			}
		}
	}

	prepareForm() {
		const _that = this;

		if (_that.elements.contact_holder) {
			_that.elements.contact_holder.innerHTML = '';
		}
		_that.removeChatButton();

		_that.elements.answer_holder.innerHTML = `
			<div class='d-flex justify-content-center align-items-center loading_content'>
				<svg viewBox='0 0 80 54' class='opacity-1' style='width: 80px; height: 54px;'>
					<use xlink:href='#svg_logo'></use>
				</svg>
				<p class='margin_vertical20' style='opacity: 0.5;'>${it('GOT_QUESTIONS')}</p>
			</div>
		`;

		const form_data = new FormData();
		form_data.append('action', 'get_help_widget_settings');
		form_data.append('message', '');

		if (_that.page_name === 'account/activity') {
			const query_string = window.location.search;
			const url_params = new URLSearchParams(query_string);
			form_data.append('page_name', `${_that.page_name}?tab=${url_params.get('tab')}`);
		} else {
			form_data.append('page_name', _that.page_name);
		}
		_that.page_ajax.help_widget_settings = _that.doAjax(
			url('/help_center_process'),
			form_data
		);
		_that.page_ajax.help_widget_settings.fetch_promise.then(response => {
			if (response.status === true) {
				_that.chat_agents_online = response.data.settings.agent_online;
				if (!_that.existsInLocalStorage('question_id')) {
					_that.addToLocalStorage('questions', response.data.questions);
				}

				if (_that.elements.contact_holder) {
					_that.elements.answer_holder.innerHTML = '';
					_that.elements.contact_holder.innerHTML = `
						<a href='${url('/help_center')}' class='btn btn-blue_border' id='go_to_helpcenter'>
							${it('MORE_HELP')}
						</a>
					`;
				}

				let category_options = '';
				for (const prop in response.data.contact_categories) {
					if (response.data.contact_categories.hasOwnProperty(prop)) {
						if (prop !== '') {
							category_options += `
								<option value='${h(prop)}'>
									${h(response.data.contact_categories[prop])}
								</option>
							`;
						} else {
							category_options += `
								<option value=''>
									${it('CONTACT_PAGE_CATEGORY')}
								</option>
							`;
						}
					}
				}

				for (const user_data in response.data.user_data) {
					if (response.data.user_data.hasOwnProperty(user_data)) {
						if (response.data.user_data[user_data] !== '') {
							const input = _that.elements.help_center_widget.querySelector('input[name=' + h(user_data) + ']');
							if (input) {
								input.value = response.data.user_data[user_data];
							}
						}
					}
				}

				const select_category = _that.elements.help_center_widget.querySelector('select[name=category_name]');
				if (select_category) {
					select_category.innerHTML = category_options;
				}

				_that.elements.answer_holder.innerHTML = '';
				if (!_that.existsInLocalStorage('question_id')) {
					_that.elements.answer_holder.innerHTML = _that.generateQuestionList(response.data.questions);
					_that.bindQuestionClick();
				} else {
					const question_id = JSON.parse(window.localStorage.getItem('question_id'));
					_that.elements.answer_holder.innerHTML = _that.generateQuestionList(JSON.parse(window.localStorage.getItem('questions')));
					_that.bindQuestionClick();
					const list_group_item = document.querySelector('.list-group-item[data-id="' + question_id + '"]');
					if (list_group_item) {
						list_group_item.click();
						_that.elements.help_center_widget.click();
					}
				}
			} else {

			}
		}).catch(error => {
			if (error.name !== 'AbortError') {
				console.log('Error: ' + error);
			}
		});
	}

	handleSearchString() {
		const _that = this;

		const search_string = _that.elements.search_input.value;
		if (search_string !== '') {
			_that.elements.search_btn.innerHTML = getSpinner();
			_that.search(search_string);
		} else {
			_that.prepareForm();
		}
	}

	bindQuestionClick() {
		const _that = this;

		const list_group_items = _that.elements.help_center_widget.querySelectorAll('.list-group-item:not(.active)');
		if (list_group_items.length > 0) {
			list_group_items.forEach(item => {
				item.addEventListener('click', e => {
					e.preventDefault();
					_that.questionClick(item.dataset.id);
				});
			});
		}
	}

	bindGoBackButtonClick() {
		const _that = this;

		const back_button = document.querySelector('.back_button');
		if (back_button) {
			back_button.addEventListener('click', e => {
				e.preventDefault();

				_that.removeChatButton();

				let answer_holder = document.getElementById('answer_holder');
				if (!answer_holder) {
					if (_that.elements.widget_form_holder) {
						const widget_heights = JSON.parse(_that.elements.widget_form_holder.dataset.heights);
						const search_section = _that.generateSearchSection();
						_that.elements.widget_form_holder.insertAdjacentHTML('beforeend', search_section);
						_that.elements.widget_form_holder.insertAdjacentHTML(
							'beforeend',
							`<div 
									id='answer_holder'
									style='${widget_heights.offset_top < 0 ? 'height: ' + widget_heights.answer_holder_height + 'px' : ''}'
								></div>
								<div id='contact_holder'></div>`
						);
						let contact_form = _that.elements.help_center_widget.querySelector('.hw_form_contact');
						if (contact_form) {
							contact_form = contact_form.cloneNode(true);
							contact_form.classList.remove('hw_form_contact');
							contact_form.classList.add('hidden');
							contact_form.setAttribute('id', 'form_contact');
							_that.elements.widget_form_holder.insertAdjacentElement('beforeend', contact_form);
							contact_form = _that.elements.help_center_widget.querySelector('.hw_form_contact');
							if (contact_form && contact_form.parentNode !== null) {
								contact_form.parentNode.removeChild(contact_form);
							}
						}
					}
					const contact_holder = _that.elements.help_center_widget.querySelector('#contact_holder');
					if (contact_holder) {
						_that.elements.contact_holder = contact_holder;
						contact_holder.insertAdjacentHTML(
							'beforeend',
							`<a href='${url('/help_center')}' class='btn btn-blue_border' id='go_to_helpcenter'>
									${it('MORE_HELP')}
								</a>`
						);
					}
				}
				const questions = JSON.parse(window.localStorage.getItem('questions'));
				answer_holder = _that.elements.help_center_widget.querySelector('#answer_holder');
				if (answer_holder) {
					_that.elements.answer_holder = answer_holder;
					answer_holder.innerHTML = _that.generateQuestionList(questions);
					_that.bindQuestionClick();
					if (_that.existsInLocalStorage('question_id')) {
						window.localStorage.removeItem('question_id');
					}
				}
			});
		}
	}

	bindChatButtonClick() {
		const _that = this;

		const hw_chat = document.getElementById('hw_chat');
		if (hw_chat) {
			hw_chat.addEventListener('click', e => {
				e.preventDefault();
				const existing_form = document.querySelector('.hw_form_contact');
				if (existing_form) {
					if (existing_form.parentNode !== null) {
						existing_form.parentNode.removeChild(existing_form);
					}
				}
				let form = document.querySelector('#form_contact');
				if (form) {
					form = form.cloneNode(true);
					form.removeAttribute('id');
					form.classList.add('hw_form_contact');
					if (_that.elements.widget_form_holder) {
						_that.elements.widget_form_holder.innerHTML = '';
					}
					form.classList.remove('hidden');
					if (_that.elements.widget_form_holder) {
						const widget_heights = JSON.parse(_that.elements.widget_form_holder.dataset.heights);
						if (widget_heights.offset_top < 0) {
							form.style.height = widget_heights.contact_holder_height + 'px';
							form.style.overflowY = 'auto';
						} else {
							form.style.height = 'auto';
						}
						_that.elements.widget_form_holder.insertAdjacentElement('beforeend', form);
						_that.bindGoBackButtonClick();
					}


					const formSubmitHandler = () => {
						const chat_with_us = document.querySelector('input[name=contact_options]:checked');
						if (chat_with_us) {
							if (chat_with_us.value === 'chat_with_us') {
								const w = window.open('about:blank', 'chat_window', 'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0,width=500,height=700');
								form.target = 'chat_window';
							} else {
								form.target = '_self';
							}
						}
						const chat_button = document.getElementById('hw_chat');
						if (chat_button) {
							chat_button.classList.add('not-visible', 'hidden');
						}
						$(':submit', form).prop('disabled', true);
						form.submit();
					}
					const constraints = {
						name: {presence: true},
						email: {
							presence: true,
							email: true
						},
						phone: {
							presence: true,
							numericality: {
								onlyInteger: true,
								message: '^' + messages.ERROR_ENTER_DIGITS_ONLY
							}
						},
						category_name: {
							presence: {
								message: '^' + messages.CONTACT_PAGE_CATEGORY
							}
						},
						message: {
							presence: true,
							length: {
								minimum: 20,
								maximum: 5000,
								message: '^' + it('ERROR_ENTER_TEXT_BETWEEN').replace('{0}', 20).replace('{1}', 5000),
							}
						}
					}

					new FormValidator({formSubmitHandler, ignoreIsHiddenInputs: false}).start(form, constraints);
				}
			});
		}
	}

	questionClick(question_id) {
		const _that = this;

		_that.logClick(question_id);
		_that.addToLocalStorage('question_id', question_id);
		const help_center_button = document.getElementById('go_to_helpcenter');
		if (help_center_button) {
			help_center_button.setAttribute('href', url('/help_center', {'qid': question_id}));
		}
		if (_that.chat_agents_online) {
			const chat_button_existing = document.getElementById('hw_chat');
			_that.removeChatButton();
			if (!chat_button_existing || !chat_button_existing.classList.contains('not-visible')) {
				if (_that.elements.contact_holder) {
					_that.elements.contact_holder.insertAdjacentHTML(
						'beforeend',
						`<a href='#' class='btn btn-orange_border' id='hw_chat'>${it('LIVE_CHAT')}</a>`
					);

					_that.bindChatButtonClick();
				}
			}
		}

		_that.generateAnswer(question_id);
	}

	generateQuestionList(data) {
		return `
			<ul class='list-group'>
				${data.map(answer => (
					`<li class='list-group-item padding_vertical10 cursor_pointer hover' data-id='${h(answer.id)}'>
						<a href='#'>${h(answer.question)}</a>
					</li>`
				)).join('')}
			</ul>
		`;
	}

	generateAnswer(question_id) {
		const _that = this;

		const data = JSON.parse(window.localStorage.getItem('questions'));
		let selected_question;
		data.forEach(question => {
			if (parseInt(question.id) === parseInt(question_id)) {
				selected_question = question;
			}
		});

		_that.elements.answer_holder.innerHTML = `
			<div class='answer_outer_holder'>
				<div class='list-group-item active'>${selected_question.question}</div>
				<div class='answer'>${selected_question.answer}</div>
				<div class='question_footer'>
					<div class='answer-fade grey' style='max-width: 100%;'></div>
					<a href='#' class='back_button margin_vertical15 display_inlineblock'>« ${it('BACK')}</a>
				</div>
			</div>
		`;

		_that.bindGoBackButtonClick();
	}

	generateSearchSection() {
		const _that = this;

		return `
			<div class='form-group'>
				<div id='search_section' class='input-group input-group-lg'>
					<input id='search_input' class='form-control input-lg' type='text' placeholder='${it('I_NEED_HELP')}'>
					<span class='input-group-btn'>
						<button id='go_search' class='btn btn-blue input-lg' type='button'>
							${_that.createSVG('0 0 24 24', ['search_icon'], '#svg_search_icon')}
						</button>
					</span>
				</div>
			</div>
		`;
	}

	existsInLocalStorage(key) {
		return window.localStorage.getItem(key) !== null;
	}

	addToLocalStorage(key, value) {
		window.localStorage.removeItem(key);
		window.localStorage.setItem(key, JSON.stringify(value));
	}

	setWidgetHeights() {
		const _that = this;

		const widget_heights = _that.calculateNewWidgetHeights(_that.elements.help_widget_btn, _that.elements.main_menu);
		if (_that.elements.widget_form_holder) {
			_that.elements.widget_form_holder.dataset.heights = JSON.stringify(widget_heights);
		}
		if (widget_heights.offset_top < 0) {
			if (_that.elements.widget_form_holder) {
				_that.elements.widget_form_holder.style.height = widget_heights.holder_height + 'px';
			}

			if (_that.elements.answer_holder) {
				_that.elements.answer_holder.style.height = widget_heights.answer_holder_height + 'px';
				_that.elements.answer_holder.style.overflowY = 'auto';
			}
		}
	}

	toggleWidgetIcon() {
		const _that = this;

		let imgSrc;
		if (_that.widget_toggled) {
			imgSrc = h(url('/images/svg_icons/help_widget/support.svg'));
		} else {
			imgSrc = h(url('/images/svg_icons/help_widget/close.svg'));
		}

		const img = _that.elements.help_widget_btn.querySelector('img');
		if (img) {
			img.setAttribute('src', imgSrc);
		}

		if (_that.widget_toggled) {
			_that.elements.help_widget_btn.classList.remove('help_widget_active', 'btn-blue', 'close_button');
			_that.elements.help_widget_btn.classList.add('btn-orange');
		} else {
			_that.elements.help_widget_btn.classList.remove('btn-orange');
			_that.elements.help_widget_btn.classList.add('btn-blue', 'help_widget_active', 'close_button');
		}
	}

	closeWidget() {
		const _that = this;

		window.localStorage.removeItem('question_id');
		window.localStorage.removeItem('questions');

		clearInterval(_that.idle_timer);
		_that.idle_timer = null;

		if (_that.elements.widget_form_holder) {
			_that.elements.widget_form_holder.classList.add('hidden');
		}
	}

	showWidget() {
		const _that = this;

		// _that.prepareForm();
		trackEvent('Help Center Widget', 'Widget Open', 'Widget Opened after being closed');

		if (_that.elements.widget_form_holder) {
			_that.elements.widget_form_holder.classList.remove('hidden');
		}

		_that.handleSearchString();

		_that.idle_timer = setInterval(() => {
			_that.calculateIdle();
		}, 1000);
	}

	calculateIdle() {
		const _that = this;

		_that.idle_time -= 1000;
		if (_that.idle_time < 0) {
			_that.closeWidget();
			_that.toggleWidgetIcon();
			_that.widget_toggled = !_that.widget_toggled;
			_that.idle_time = _that.idle_time_amount;
		}
	}

	doAjax(url, data) {
		console.log('HelpCenterWidget::doAjax(%o, %o)', url, data);

		const abort_controller = new AbortController();
		const fetch_promise = new Promise((resolve, reject) => {
			fetch(url, {
				method: 'POST',
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				},
				body: data,
				signal: abort_controller.signal
			})
				.then((response) => {
					return response.json();
				})
				.then((json) => {
					resolve(json);
				})
				.catch((error) => {
					reject(error);
				});
		});

		return {fetch_promise, abort_controller};
	}
}
